module.exports = __webpack_public_path__ + "9bed5345180ca2be900929f411766287.png";